"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const IndiText = _ref => {
  let {
    uxCSSClass = "text-color-primary"
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
    className: "text-lowercase",
    children: ["indigen", /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "".concat(uxCSSClass, " font-weight-semibold"),
      children: "ux"
    })]
  });
};
IndiText.defaultProps = {};
var _default = exports.default = IndiText;